<template>
  <div v-if="$store.getters.guardMode !== $store.getters.guardModes.GUARD_MODE_SKIP">

    <template v-if="$store.getters.notAccess === true">
      <div class="notAccessText">Вы пытаетесь попасть в&nbsp;приватный бот с&nbsp;паролем. Введите верный пароль в&nbsp;боте, чтобы получить доступ к&nbsp;каталогу.</div>
    </template>

    <template v-else-if="$store.getters.guardOutlets.length">
      <div class="guard-container">
        <transition-group :name="slide_direction">
          <guard-city
            style="position: absolute; width: 100%; max-width: 420px"
            :key="'city'"
            ref="city"
            :cityData.sync="city"
            v-if="
              $store.getters.guardMode ===
              $store.getters.guardModes.GUARD_MODE_CITY
            "
          />

          <guard-order-type-and-outlet
            style="position: absolute; width: 100%; max-width: 420px"
            :key="'orderTypeAndOutlet'"
            ref="orderTypeAndOutlet"
            :identifierData.sync="identifier"
            :typeIdData.sync="type_id"
            v-if="
              $store.getters.guardMode ===
                $store.getters.guardModes.GUARD_MODE_ORDER_TYPE_AND_OUTLETS ||
              $store.getters.guardMode ===
                $store.getters.guardModes.GUARD_MODE_OUTLETS
            "
          />

          <guard-address
            style="position: absolute; width: 100%; max-width: 420px"
            :key="'address'"
            ref="address"
            :addressData.sync="address"
            v-if="
              $store.getters.guardMode ===
              $store.getters.guardModes.GUARD_MODE_ADDRESS
            "
            @back="setSlideDirection"
          />

          <guard-area
            style="position: absolute; width: 100%; max-width: 420px"
            :key="'area'"
            :areaData.sync="area"
            ref="area"
            v-if="
              $store.getters.guardMode ===
              $store.getters.guardModes.GUARD_MODE_AREA
            "
          />
        </transition-group>

        <div :key="'button'" class="fixed_bottom_basket plr">
          <transition name="super-slide">
            <a
              @click="callNext()"
              class="fbb_btn"
              style="margin-top: 20px; margin-bottom: 20px; cursor: pointer"
              v-show="showButton"
            >
              {{ text('bottom_button_to_form') }}
            </a>
          </transition>
        </div>
      </div>

      <div style="text-align: center" v-if="$store.getters.showMadeViaDigarson">
        <Footer/>
      </div>
    </template>

    <template v-else>
      <template v-if="$store.getters.notWorking">
        <div style="text-align: center" v-show="!$store.getters.overlay">
          <span
            style="
              font-size: 28px;
              padding: 40px 20px;
              display: block;
              font-weight: 600;
            "
          >{{ text('not_working') }}</span
          >
          <img
            style="height: 200px; width: 200px"
            :src="require('@/assets/img/summer.png')"
          />
        </div>
      </template>
      <template v-else>
        <div style="text-align: center" v-show="!$store.getters.overlay">
          <span
            style="
              font-size: 28px;
              padding: 40px 20px;
              display: block;
              font-weight: 600;
            "
          >{{ text('under_construction') }}</span
          >
          <img
            style="height: 200px; width: 200px"
            :src="require('@/assets/img/under-construction.png')"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import GuardAddress from '@/components/Default/Guard/Address'
  import GuardArea from '@/components/Default/Guard/Area'
  import GuardOrderTypeAndOutlet from '@/components/Default/Guard/OrderTypeAndOutlet'
  import GuardCity from '@/components/Default/Guard/City'
  import Footer from '@/components/Default/Footer'

  import {GUARD_INIT, GUARD_DISABLE} from '@/store/actions.type'
  import api from '@/api'

  export default {
    name: 'Guard',

    data() {
      return {
        city: null,
        identifier: null,
        type_id: null,
        address: null,
        area: null,
        slide_direction: 'left'
      }
    },

    components: {
      Footer,
      GuardCity,
      GuardAddress,
      GuardOrderTypeAndOutlet,
      GuardArea
    },

    computed: {
      showButton() {
        switch (this.$store.getters.guardMode) {
          case this.$store.getters.guardModes.GUARD_MODE_CITY:
            return this.city !== null
          case this.$store.getters.guardModes.GUARD_MODE_ORDER_TYPE_AND_OUTLETS:
            return (
              this.identifier !== null ||
              (this.type_id === 3 && this.$store.getters.guardAddressEnabled)
            )
          case this.$store.getters.guardModes.GUARD_MODE_OUTLETS:
            return this.identifier !== null
          case this.$store.getters.guardModes.GUARD_MODE_ADDRESS:
            return this.address !== null
          case this.$store.getters.guardModes.GUARD_MODE_AREA:
            return this.area !== null
          default:
            return false
        }
      },
      guardOutlets() {
        return this.$store.getters.guardOutlets
      }
    },

    methods: {
      setSlideDirection(direction) {
        this.slide_direction = direction
        setTimeout(() => (this.slide_direction = 'rtl-left'), 300)
      },
      async callNext() {
        switch (this.$store.getters.guardMode) {
          case this.$store.getters.guardModes.GUARD_MODE_CITY:
            return await this.$refs.city.next()
          case this.$store.getters.guardModes.GUARD_MODE_ORDER_TYPE_AND_OUTLETS:
            return await this.$refs.orderTypeAndOutlet.next()
          case this.$store.getters.guardModes.GUARD_MODE_OUTLETS:
            return await this.$refs.orderTypeAndOutlet.next()
          case this.$store.getters.guardModes.GUARD_MODE_ADDRESS:
            return await this.$refs.address.next()
          case this.$store.getters.guardModes.GUARD_MODE_AREA:
            return await this.$refs.area.next()
          default:
            return null
        }
      }
    },

    async mounted() {
      if (!this.guardOutlets || this.guardOutlets.length === 0) {
        await this.$store.dispatch(GUARD_INIT)
      }
      // await this.$store.dispatch(GUARD_INIT);
      if (this.$store.getters.guardCssDirection === 'rtl') {
        this.slide_direction = 'rtl-left'
      }
    }
  }
</script>

<style scoped>
  .guard-container {
    min-height: calc(100vh - 43px);
  }

  .left-enter-active {
    transition: all 0.4s ease;
  }

  .left-leave-active {
    transition: all 0.4s ease;
  }

  .left-enter,
  .left-leave-to {
    transform: translateX(100vw);
    opacity: 0;
  }

  .rtl-left-enter-active,
  .rtl-left-leave-active {
    transition: all 0.4s ease;
  }

  .rtl-left-enter {
    transform: translateX(-100vw);
    opacity: 0;
  }

  .rtl-left-leave-to {
    transform: translateX(100vw);
    opacity: 0;
  }

  .right-enter-active,
  .right-leave-active {
    transition: all 0.4s ease;
  }

  .right-enter {
    transform: translateX(100vw);
    opacity: 0;
  }

  .right-leave-to {
    transform: translateX(-100vw);
    opacity: 0;
  }

  .guard-container {
    min-height: calc(100vh - 43px);
  }

  .super-slide-enter-active,
  .super-slide-leave-active {
    transition: all 0.5s ease;
  }

  .super-slide-enter,
  .super-slide-leave-to {
    transform: translateY(300%);
  }

  .super-slide-down-enter-active,
  .super-slide-down-leave-active {
    transition: all 0.5s ease;
    background: rgba(255, 255, 255, 1) !important;
  }

  .super-slide-down-enter,
  .super-slide-down-leave-to {
    transition: all 0.5s ease;
    transform: translateY(-300%);
    background: rgba(255, 255, 255, 0) !important;
  }

  .notAccessText {
      font-size: 28px;
      padding: 40px 20px;
      display: block;
      font-weight: 600;
      color: #000;
      text-align: center;
  }
</style>
